import { render, staticRenderFns } from "./CoolingWaterControls.vue?vue&type=template&id=56eaaeb8&"
import script from "./CoolingWaterControls.vue?vue&type=script&lang=ts&"
export * from "./CoolingWaterControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports